import { render, staticRenderFns } from "./secondReturnSet.vue?vue&type=template&id=906a0622&scoped=true&"
import script from "./secondReturnSet.vue?vue&type=script&lang=js&"
export * from "./secondReturnSet.vue?vue&type=script&lang=js&"
import style0 from "./secondReturnSet.vue?vue&type=style&index=0&id=906a0622&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906a0622",
  null
  
)

export default component.exports